const _excluded = ["dataTestId", "initialValue", "onFilter", "options", "showPlusButton"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import MultiChoiceFilter from './MultiChoiceFilter';
export default function SelectFilter(_ref) {
  let {
      dataTestId,
      initialValue = '',
      onFilter,
      options,
      showPlusButton = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MultiChoiceFilter, _extends({
    dataTestId: dataTestId,
    initialValue: initialValue,
    onChange: onFilter,
    options: options,
    showPlusButton: showPlusButton,
    type: "select"
  }, props));
}